// import Signin from "../../pages/users/Signin";
import { API_BASE_URL } from "../constant";
import { getAdminById, getAllAdmin, updateAdmin } from "./admin";
import { signIn, signUp } from "./auth";
import {
  createCompany,
  createForm,
  deleteCompany,
  getAllCompanies,
  getCompanyById,
  updateCompany,
  updateCompanyProfile,
  postSubmissionFile
} from "./company";

import {
  createSubmission,
  getAllResponses,
  getCompanyResponses,
  getDataInCsv,
  getSubmission
} from "./submissions";
import {
  getAllEmployee,
  getAllSupervisor,
  getCompanyUsers,
  getUserById,
  usersSignIn,
  usersSignUp,
} from "./users";

const API = {
  users: {
    usersSignIn,
    usersSignUp,
    getCompanyUsers,
    getUserById,
    getAllEmployee,
    getAllSupervisor,
  },
  auth: {
    signIn,
    signUp,
  },
  admin: {
    getAllAdmin,
    getAdminById,
    updateAdmin,
  },
  submissions: {
    createSubmission,
    getCompanyResponses,
    getAllResponses,
    getDataInCsv,
    getSubmission
  },
  company: {
    createCompany,
    createForm,
    getCompanyById,
    getAllCompanies,
    updateCompany,
    deleteCompany,
    updateCompanyProfile,
    postSubmissionFile
  },
};
export default API;

export const formCreate = (data) => API_BASE_URL.post("forms/create", data);
